import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.2, 0.7, 0.1, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Comp>
  );
}

const lineVariant = {
  hidden: { y: "108%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, delay: 0.12 * i, ease: EASE } }),
};

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export function MaskLines({ lines, className = "", lineClassName = "", onLoad = false, delay = 0, as = "h2", testId }) {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <Comp className={className} initial={reduce ? false : "hidden"} {...trigger} data-testid={testId}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
          <motion.span
            className={`block ${typeof l === "object" && l.className ? l.className : lineClassName}`}
            variants={lineVariant}
            custom={i + delay / 0.12}
          >
            {typeof l === "object" ? l.text : l}
          </motion.span>
        </span>
      ))}
    </Comp>
  );
}

export function ClipImage({ src, alt, className = "", imgClassName = "", testId, ...rest }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={`relative overflow-hidden ${className}`}
      initial={reduce ? false : { clipPath: "inset(14% 10% 14% 10%)" }}
      whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.3, ease: EASE }}
      data-testid={testId}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`h-full w-full object-cover ${imgClassName}`}
        initial={reduce ? false : { scale: 1.18 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 1.6, ease: EASE }}
        {...rest}
      />
    </motion.div>
  );
}
